import { render, staticRenderFns } from "./ProfileAcademicTrainingAddEdit.vue?vue&type=template&id=1753158e"
import script from "./ProfileAcademicTrainingAddEdit.vue?vue&type=script&lang=js"
export * from "./ProfileAcademicTrainingAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports